import React from 'react';
import PropTypes from 'prop-types';
import { compose, pure } from '../../../../src/web/utils/react';
import Field from '../../../../modules/react/components/stateful/Field';
import Input from '../../../../modules/react/components/stateful/Input';
import PhoneInput from '../../../../modules/react/components/stateful/PhoneInput';
import styles from './BasicTenantForm.scss';

const BasicTenantForm = ({ required }) => (
  <div className="facility-info">
    <Field
      className={`form-control ${styles.field}`}
      label="First Name"
      key="firstName"
      id="basicTenantForm-firstName"
      name="firstName"
      component={Input}
      required={required}
    />
    <Field
      className={`form-control ${styles.field}`}
      label="Last Name"
      key="lastName"
      id="basicTenantForm-lastName"
      name="lastName"
      component={Input}
      required={required}
    />
    <Field
      className={`form-control ${styles.field}`}
      label="Email"
      key="email"
      id="basicTenantForm-email"
      name="email"
      type="email"
      component={Input}
      required={required}
    />
    <Field
      className={`form-control ${styles.field}`}
      label="Phone"
      key="phone"
      id="basicTenantForm-phone"
      name="phone"
      component={PhoneInput}
      required={required}
    />
  </div>
);

BasicTenantForm.propTypes = {
  required: PropTypes.bool,
};

BasicTenantForm.defaultProps = {
  required: false,
};

export default compose(
  pure(),
)(BasicTenantForm);
